/**
 * Embedded Video
 * 
 * Ersetzt vorhandende Placeholder Videos beim Klick durch das eigentliche YouTube Video iFrame und 
 * verbessert somit die Ladezeit & den Einsatz von Third-Party-Cookies
 * 
 * @version   1.0.1
 * @author    Erwin Müller Versandhaus GmbH
 */
$(function(){
  var embeddedVideos = document.getElementsByClassName( 'embedded-video' );
  for( var i = 0; i < embeddedVideos.length; i++ ) { 
    // Eventlistener für alle Placeholder Player setzzen
    embeddedVideos[i].addEventListener( 'click', function(e) { 
      // Video iFrame Element erstellen
      var iFrame = document.createElement( 'iframe' );
      iFrame.setAttribute( 'frameborder', '0' );
      iFrame.setAttribute( 'allowfullscreen', '' );
      iFrame.setAttribute( 'src', 'https://www.youtube-nocookie.com/embed/' + this.dataset.embedded + '?rel=0&showinfo=0&autoplay=1' );
      // Placeholder leeren & iFrame einbinden
      this.innerHTML = '';
      this.appendChild( iFrame );
    });
  }
})
